export const Profils = {
    ADM: 'ADM',
    ADR: 'ADR',
    ATC: 'ATC',
    CA: 'CA',
    CDS: 'CDS',
    CDV: 'CDV',
    CV: 'CV',
    DA: 'DA',
    DC: 'DC',
    DR: 'DR',
    ENT: 'ENT',
    INA: 'INA',
    MAB: 'MAB',
    Magasinier: 'MAG',
    Sedentaire: 'SED',
    SIE: 'SIE',
    SIEGE: 'SIEGE'
} as const;
